import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_SUCCESS,
  CHANGE_NOTIFICATIONS_STATUS,
  CHANGE_NOTIFICATIONS_STATUS_FAILURE,
  CHANGE_NOTIFICATIONS_STATUS_SUCCESS,
} from "../constants";

export default class NotificationsAction {
  static getNotifications(payload, cb) {
    return {
      type: GET_NOTIFICATIONS,
      payload,
      cb,
    };
  }
  static getNotificationsSuccess(payload) {
    return {
      type: GET_NOTIFICATIONS_SUCCESS,
      payload,
    };
  }
  static getNotificationsFailure(payload) {
    return {
      type: GET_NOTIFICATIONS_FAILURE,
      payload,
    };
  }
  static changeNotificationsStatus(payload, cb) {
    return {
      type: CHANGE_NOTIFICATIONS_STATUS,
      payload,
      cb,
    };
  }
  static changeNotificationsStatusSuccess(payload) {
    return {
      type: CHANGE_NOTIFICATIONS_STATUS_SUCCESS,
      payload,
    };
  }
  static changeNotificationsStatusFailure(payload) {
    return {
      type: CHANGE_NOTIFICATIONS_STATUS_FAILURE,
      payload,
    };
  }
}
